import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useAppContext } from "../../../../../../../AppContext";
import SearchDropdown from "../../../../../../search/seatchDropdown";

const initialFieldState = {
  group: {
    data: [],
    value: "",
    message: "",
    state: null,
  },
  name: {
    value: "",
    message: "",
    state: null,
  },
  level: {
    value: [],
    message: "",
    state: null,
  },
  user: {
    value: [
      {
        id: "",
        name: "",
        state: null,
      },
    ],
    data: [],
    rawData: [],
    message: "",
    state: null,
  },
};

function CreateBrand() {
  const { user, chimeraserv } = useAppContext();
  const [reset, setReset] = useState(Date.now());
  const [title] = useState("Create Brand | Chimera Solutions | Insights");
  const [form, setForm] = useState({ state: null, message: "" });
  const [field, setField] = useState({ ...initialFieldState });
  const timeRef = useRef(null);

  const headers = {
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const renderTitle = () => (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );

  const validateFields = () => {
    setForm((prev) => ({ ...prev, state: false }));

    if (field.name.state && field.group.state && field.level.state) {
      setForm((prev) => ({ ...prev, state: true }));
    }
  };

  const validateLevelStates = () => {
    const hasSelectedLevels =
      field.level.value.filter((level) => level.status).length > 0;

    setField((prev) => ({
      ...prev,
      level: {
        ...prev.level,
        state: hasSelectedLevels,
        message: hasSelectedLevels ? "" : "please select a user level",
      },
    }));

    //setTimeout(() => validateFields(), 100);
  };

  const checkField = (data) => {
    clearTimeout(timeRef.current);
    timeRef.current = setTimeout(() => {
      if (data.getAttribute("data-field")) {
        const fieldName = data.getAttribute("data-field");

        switch (fieldName) {
          case "level":
            let state = true;
            let message = "";

            const checkLevels = field.level.value.filter(
              (level) => level.status
            ).length;

            if (!checkLevels) {
              state = false;
              message = "please select a user level";
            }

            setField((prev) => ({
              ...prev,
              [fieldName]: {
                ...prev[fieldName],
                message: message,
                state: state,
              },
            }));
            // setTimeout(() => validateLevelStates(), 100);
            break;
          default:
            break;
        }
      } else {
        switch (data.id) {
          case "group":
            // Reset all dependent fields first
            setField((prev) => ({
              ...prev,
              group: {
                ...prev.group,
                value: "",
                state: null,
              },
              name: {
                ...prev.name,
                value: "",
                state: null,
              },
              level: {
                ...prev.level,
                value: [],
                state: null,
                message: "",
              },
              user: {
                ...prev.user,
                value: [
                  {
                    id: "",
                    name: "",
                    state: null,
                  },
                ],
                data: [],
                state: null,
                message: "",
              },
            }));

            if (data.value !== "0") {
              const group = JSON.parse(data.value);
              setField((prev) => {
                const levelsWithStatus = prev.group.data
                  .find((res) => res.grpKey === group.grpKey)
                  .levels.map((level, key) => {
                    let status = 0;
                    if (!key) {
                      status = 1; // First level selected by default
                    }
                    return { ...level, status: status };
                  });

                // Check if any levels are selected
                const hasSelectedLevels =
                  levelsWithStatus.filter((level) => level.status).length > 0;

                return {
                  ...prev,
                  group: {
                    ...prev.group,
                    value: data.value,
                    state: true,
                  },
                  level: {
                    ...prev.level,
                    value: levelsWithStatus,
                    state: hasSelectedLevels, // Set state based on selected levels
                  },
                  user: {
                    ...prev.user,
                    data: prev.user.rawData.filter(
                      (user) => user.group === group._id
                    ),
                  },
                };
              });
            }
            break;

          case "name":
            if (data.value.length) {
              let state = true;
              let message = "";

              if (data.value.length <= 3) {
                state = false;
                message = "brand name should be minimum of 4 characters \n";
              }
              // Parse the group value to get the grpKey
              let currentGroupKey = "";
              if (field.group.value && field.group.value !== "0") {
                try {
                  const groupData = JSON.parse(field.group.value);
                  currentGroupKey = groupData.grpKey;
                } catch (e) {
                  console.error("Error parsing group value:", e);
                }
              }

              if (
                currentGroupKey &&
                [].concat
                  .apply(
                    [],
                    [].concat.apply(
                      [],
                      field.group.data
                        .filter((data) => data.grpKey === field.group.value)
                        .map((data) => data.brands.map((brand) => brand.name))
                    )
                  )
                  .find((name) => name === data.value)
              ) {
                state = false;
                message = "brand name exist \n";
              }

              setField((prev) => ({
                ...prev,
                [data.id]: {
                  ...prev[data.id],
                  value: data.value,
                  state: state,
                  message: message,
                },
              }));
              //setTimeout(() => validateFields(), 100);
            }
            break;
          default:
            break;
        }
      }
    }, 500);
  };

  const valueChanged = (event) => {
    const element = event.target;

    if (element.getAttribute("data-field")) {
      const fieldName = element.getAttribute("data-field");
      const key = element.getAttribute("data-key");

      setField((prev) => {
        const value = prev[fieldName].value.map((data, index) => {
          const valueData = data;

          if (index === Number(key)) {
            switch (fieldName) {
              case "level":
                valueData.status = data.status ? 0 : 1;
                break;
              default:
                break;
            }
          }

          return valueData;
        });

        return {
          ...prev,
          [fieldName]: {
            ...prev[fieldName],
            value: value,
            message: "",
            state: null,
          },
        };
      });
    } else {
      setField((prev) => ({
        ...prev,
        [element.id]: {
          ...prev[element.id],
          value: element.value,
          message: "",
          state: null,
        },
      }));
    }

    setForm((prev) => ({ ...prev, state: false }));
    checkField(element);
  };

  const checker = (state) => {
    const check = {
      icon: "check-circle",
      style: "null",
    };

    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }

    return check;
  };

  const getUser = async () => {
    try {
      const response = await axios.get(chimeraserv.urlGet + "/user", {
        headers,
      });
      setField((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          rawData: response.data,
        },
      }));
    } catch (error) {
      // handle error if needed
    }
  };

  const getGroup = async () => {
    try {
      const response = await axios.get(chimeraserv.urlGet + "/group", {
        headers,
      });
      setField((prev) => ({
        ...prev,
        group: {
          ...prev.group,
          data: response.data,
        },
      }));
    } catch (error) {
      // handle error if needed
    }
  };

  const resetForm = () => {
    setReset(Date.now());
    // setField({ ...initialFieldState });
    setField((prev) => ({
      ...initialFieldState,
      group: {
        ...prev.group, // Keep existing group data
        value: "",
        state: null,
      },
      user: {
        ...prev.user, // Keep existing user data
        value: [
          {
            id: "",
            name: "",
            state: null,
          },
        ],
        state: null,
        message: "",
      },
    }));
    setForm({ state: null, message: "" });
  };

  const add = () => {
    setField((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        value: [
          ...prev.user.value,
          {
            id: parseInt(prev.user.value.length + 1),
            name: "",
            state: null,
          },
        ],
        message: "",
        state: null,
      },
    }));
  };

  const remove = (key) => {
    const newUsers = field.user.value.filter((_, index) => key !== index);

    setField((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        value: newUsers,
        message: "",
        state: null,
      },
    }));
  };

  const submit = async () => {
    setForm((prev) => ({
      ...prev,
      state: false,
      message: "",
    }));

    try {
      // Parse the group value to get the grpKey
      let groupKey = "";
      if (field.group.value && field.group.value !== "0") {
        try {
          const groupData = JSON.parse(field.group.value);
          groupKey = groupData.grpKey;
        } catch (e) {
          console.error("Error parsing group value:", e);
          groupKey = field.group.value; // Fallback
        }
      }
      const response = await axios.post(
        `${chimeraserv.urlPost}/group/create/brand`,
        {
          grpKey: groupKey,
          name: field.name.value,
          levels: field.level.value
            .filter((level) => level.status)
            .map((level) => level.id),
          users: field.user.value.filter((user) => user.state),
        },
        { headers }
      );
      if (response.data && !response.data.__v) {
        resetForm();
        setForm((prev) => ({
          ...prev,
          message: "Brand Created",
        }));
      }
    } catch (error) {
      setForm((prev) => ({
        ...prev,
        message: JSON.stringify(error),
      }));
    }
  };
  // Add this useEffect to validate levels when they change
  useEffect(() => {
    if (field.level.value.length > 0) {
      const hasSelectedLevels =
        field.level.value.filter((level) => level.status).length > 0;

      setField((prev) => ({
        ...prev,
        level: {
          ...prev.level,
          state: hasSelectedLevels,
          message: hasSelectedLevels ? "" : "please select a user level",
        },
      }));
    }
  }, [field.level.value]);

  // Add useEffect for overall form validation
  useEffect(() => {
    validateFields();
  }, [field.name.state, field.group.state, field.level.state]);

  useEffect(() => {
    getGroup();
    getUser();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (reset) {
      getGroup();
    }
    // eslint-disable-next-line
  }, [reset]);

  return (
    <div className={"custForm"}>
      {renderTitle()}

      <div className={["viewTitle"]}>Create New Brand</div>
      <form onSubmit={() => {}} className={["form"]}>
        <div className={["form-group"]}>
          <label htmlFor="group">
            Group <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.group.state).style].join(" ")}
            icon={["fas", checker(field.group.state).icon]}
          />
          <SearchDropdown
            data={field.group.data}
            name="group"
            value={field.group.name}
            searchFields={["name", "grpKey"]}
            displayField="name"
            placeholder="Search business group..."
            required={true}
            showIcon={false}
            state={!!field.group.state}
            onSelect={(group) => {
              // Simulate a change event for valueChanged
              const fakeEvent = {
                target: {
                  id: "group",
                  value: JSON.stringify({
                    name: group.name,
                    grpKey: group.grpKey,
                    _id: group._id,
                  }),
                  getAttribute: (attr) => {
                    if (attr === "data-field") return null;
                    if (attr === "data-key") return null;
                    return undefined;
                  },
                },
              };
              valueChanged(fakeEvent);
            }}
            allowClear={true}
            noResultsText="No groups found"
          />
          {/* <select
            className="form-control"
            id="group"
            onChange={valueChanged}
            // value={field.group.value}
            value={field.group.value || "0"}
          >
            <option value={0}>-- business group of brand --</option>
            {field.group.data.map((data, key) => (
              <option
                value={JSON.stringify({
                  name: data.name,
                  grpKey: data.grpKey,
                  _id: data._id,
                })}
                key={key}
              >
                {data.name}
              </option>
            ))}
          </select> */}
        </div>
        <div className={["form-group"]}>
          <label>
            Brand Name <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.name.state).style].join(" ")}
            icon={["fas", checker(field.name.state).icon]}
          />
          <div className={["field"]}>
            <input
              type={"text"}
              className={["form-control"]}
              id={"name"}
              placeholder={"enter brand name"}
              value={field.name.value}
              onChange={valueChanged}
            />
            <span>{field.name.message}</span>
          </div>
        </div>
        <div className={["form-group"]}>
          <label htmlFor="type">
            Levels <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(field.level.state).style].join(" ")}
            icon={["fas", checker(field.level.state).icon]}
          />
          <div className={["custom-control", "custom-checkbox"].join(" ")}>
            {field.level.value.map((data, key) => {
              return (
                <div key={key}>
                  <input
                    type={"checkbox"}
                    className={["custom-control-input"]}
                    name="level"
                    id={key}
                    data-key={key}
                    onChange={valueChanged}
                    checked={data.status}
                    value={data.id}
                    data-field={"level"}
                  />
                  <label className={"custom-control-label"} htmlFor={key}>
                    {data.name}
                  </label>
                </div>
              );
            })}
            <div className={["field"]}>
              <span>{field.level.message}</span>
            </div>
          </div>
        </div>
        {/* <div className={["form-group"]}>
          <label>
            Users <span></span>
          </label>
          <div className={"multipart"}>
            {field.user.value.map((data, key) => (
              <div className={["field"]} key={key}>
                <div className={"part"}>
                  <FontAwesomeIcon
                    className={["icon", checker(data.state).style].join(" ")}
                    icon={["fas", checker(data.state).icon]}
                  />
                  <input
                    type={"text"}
                    className={["form-control", "custField"].join(" ")}
                    id={"name"}
                    placeholder={"enter level name"}
                    value={data.name}
                    data-key={key}
                    onChange={valueChanged}
                    data-field={"user"}
                  />
                  <button
                    type={"button"}
                    onClick={() => (key === 0 ? add() : remove(key))}
                    className={["custBtn", key === 0 ? "add" : "remove"].join(
                      " "
                    )}
                  >
                    <FontAwesomeIcon
                      className={["icon", checker(field.user.state).style].join(
                        " "
                      )}
                      icon={key === 0 ? "plus" : "minus"}
                    />
                  </button>
                </div>
                <span>{data.message}</span>
              </div>
            ))}
          </div>
        </div> */}
        {form.message ? (
          <div className={["message", "form-group"].join(" ")}>
            <FontAwesomeIcon
              className={["icon", "correct"].join(" ")}
              icon={"check-circle"}
            />
            {form.message}
          </div>
        ) : (
          <div />
        )}
        <button
          type={"button"}
          className={["btn btn-primary"]}
          disabled={!form.state}
          onClick={submit}
        >
          Create
        </button>
        <button
          type={"button"}
          onClick={resetForm}
          className={["btn btn-primary", "reset"].join(" ")}
        >
          Reset
        </button>
      </form>
    </div>
  );
}

export default CreateBrand;
